module.exports = __webpack_public_path__ + "img/responsible-gambling-bg-mob.f9a8f0ff.png";